import React from 'react';
import ListPage from '../../base/ListPage.js';
import APILXD from '../../../http/APILXD.js';
import { Modal, message, Popover, Badge, Tag, Button } from 'antd';
import HttpTool from "../../../tool/HttpTool";
import styles from "./index.less";
import ModalBase from "../../../components/modalBase";
import ModalDelete from "../../../components/modalDelete/ModalDelete";
import TimeHelp from "../../../tool/TimeHelp";
import dayjs from 'dayjs';
import DigitalCountComboSet from "./component/DigitalCountComboSet";
import Help from "../../../tool/Help";
import classNames from "classnames";

const MB = new ModalBase()
const MD = new ModalDelete()


export default class DigitalHumanPrice extends ListPage {
  constructor(props) {
    super(props);

    this.previewData = null;  //套餐预览数据
  }

  base_getListConfig() {
    return {
      table: {
        columns: this.getTableColumns(),
        url: APILXD.pricePackageGetList,
        otherParam: {
          productType: 'human_package'
        },
      },
      new: {
        defaultValue: '新增数字人席位套餐',
        action: () => {
          this.add();
        }
      },
      search: {
        seniorSearch: this.getSeniorSearch(),
        option: {
          openSenior: true,
          placeholder: '请输入套餐名称搜索',
          reg: /^[\s\S]*$/,
          beforeSubmit: (value) => {
            if (value.keyword) {
              value.name = value.keyword
            }
            delete value.keyword
            if (value.enable) {
              value.enable = value.enable === 1
            }

            return true;
          },
        }
      }
    }
  }

  getSeniorSearch() {
    return {
      colCount: 3,
      formItemLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 18, offset: 0 },
      },
      parameterArr: [
        {
          field: "enable",
          name: "状态",
          type: 'select',
          selectType: 'value',
          reg: (v) => {
            return true;
          },
          option: {
            allowClear: true,
          },
          data: [
            {
              title: '已上架',
              value: 1,
            },
            {
              title: '已下架',
              value: 2,
            },
          ]
        },
      ],
    }
  }


  comboValid(param) {
    return typeof param.comboSet?.price === 'number' && typeof param.comboSet?.month === 'number' && typeof param.comboSet?.countNum === 'number'
  }

  getAddData(defaultData) {
    let defaultOption = {
      type: "input",
      ver: true,
      reg: /^[\S\s]{0,50}$/,
      verMessage: "请填写，最多50个字符",
      required: true,
    };

    this.previewData = {
      name: defaultData?.name,
      remark: defaultData?.remark,
      tagList: defaultData?.tagList,
      comboSet: defaultData ? {
        price: defaultData.price / 100,
        month: defaultData.monthLimit,
        countNum: defaultData.countLimit,
      } : {}
    };

    let props = {
      colCount: 1,
      formItemLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 18, offset: 0 },
      },
      parameterArr: [
        {
          ...defaultOption,
          field: "name",
          name: "套餐名称",
          type: 'input',
          reg: /^[\S\s]{1,30}$/,
          verMessage: "请填写，最多30个字符",
          option: {
            maxLength: "30",
            defaultValue: defaultData?.name
          },
          onChange: (value, state, changeState) => {
            this.previewData.name = value;
          }
        },
        {
          ...defaultOption,
          field: "nameEn",
          name: "套餐名称（英文）",
          type: 'input',
          reg: /^[\S\s]{1,30}$/,
          verMessage: "请填写，最多50个字符",
          option: {
            maxLength: "50",
            defaultValue: defaultData?.nameEn
          },
          onChange: (value, state, changeState) => {
            this.previewData.nameEn = value;
          }
        },
        {
          ...defaultOption,
          field: "comboSet",
          name: "席位套餐内容",
          type: 'diy',
          component: DigitalCountComboSet,
          reg: (v) => {
            return true

            //触发太频繁，改成提交前校验
            // return typeof v.price === 'number' && typeof v.month === 'number' && typeof v.countNum === 'number'
          },
          verMessage: "请检查套餐内容",
          option: {
            defaultValue: defaultData ? {
              price: defaultData.price / 100,
              month: defaultData.monthLimit,
              countNum: defaultData.countLimit,
            } : {}
          },
          onChange: (value, state, changeState) => {
            this.previewData.comboSet = value;
            this.previewData.data = value;
          }
        },
        {
          ...defaultOption,
          field: "targetTag",
          name: "适用用户",
          type: 'Select',
          selectType: 'value',
          verMessage: "请选择适用用户",
          reg: (v) => {
            return !!v
          },
          option: {
            defaultValue: defaultData?.targetTag ? {
              key: defaultData.targetTag,
              value: defaultData.targetTag,
            } : null
          },
          apiConfig: {
            url: APILXD.pricePackageTargetTag,
            fillObject: (json) => {
              return json?.map((item) => {
                return {
                  title: item.desc,
                  value: item.code
                }
              });
            }
          },
        },
        {
          ...defaultOption,
          field: "eventTimeSet",
          name: "套餐活动期",
          type: 'RangePicker',
          required: false,
          reg: () => {
            return true
          },
          option: {
            style: { width: "100%" },
            defaultValue: (defaultData && defaultData?.eventEndTime) ? [dayjs(defaultData?.eventStartTime), dayjs(defaultData?.eventEndTime)] : null,
            disabledDate: (value) => {
              if (!value) {
                return false;
              }
              let nowDate = new Date();
              return value.valueOf() < nowDate.valueOf() - 86400000;
            },
          }
        },
        {
          ...defaultOption,
          field: "tagList",
          name: "套餐标签",
          type: 'SelectAll',
          selectType: 'value',
          required: false,
          reg: (v) => {
            if (!v?.length) {
              return true
            }

            return !(v.some((item) => { return item.length > 5 }))
          },
          verMessage: "每个标签最多使用5个字符",
          option: {
            mode: 'tags',
            placeholder: "请输入标签内容",
            maxLength: 50,
            onSearch: (v) => {
            },
            defaultValue: defaultData?.tagList?.length ? defaultData?.tagList.map((name) => {
              return {
                label: name,
                value: name,
              }
            }) : null
          },
          onChange: (value, state, changeState) => {
            this.previewData.tagList = value;
          }
        },
        {
          ...defaultOption,
          field: "tagListEn",
          name: "套餐标签（英文）",
          type: 'SelectAll',
          selectType: 'value',
          required: false,
          reg: (v) => {
            if (!v?.length) {
              return true
            }

            return !(v.some((item) => { return item.length > 20 }))
          },
          verMessage: "每个标签最多使用20个字符",
          option: {
            mode: 'tags',
            placeholder: "请输入标签内容",
            maxLength: 50,
            onSearch: (v) => {
            },
            defaultValue: defaultData?.tagListEn?.length ? defaultData?.tagListEn.map((name) => {
              return {
                label: name,
                value: name,
              }
            }) : null
          },
          onChange: (value, state, changeState) => {
            this.previewData.tagListEn = value;
          }
        },
        {
          ...defaultOption,
          field: "remark",
          name: "套餐说明",
          type: 'TextArea',
          required: false,
          reg: (v) => {
            return true
          },
          option: {
            maxLength: "50",
            defaultValue: defaultData?.remark
          },
          onChange: (value, state, changeState) => {
            this.previewData.remark = value;
          }
        },
        {
          ...defaultOption,
          field: "remarkEn",
          name: "套餐说明（英文）",
          type: 'TextArea',
          required: false,
          reg: (v) => {
            return true
          },
          option: {
            maxLength: "50",
            defaultValue: defaultData?.remarkEn
          },
          onChange: (value, state, changeState) => {
            this.previewData.remarkEn = value;
          }
        },
        {
          ...defaultOption,
          field: "sort",
          name: "排序",
          type: "inputNumber",
          required: false,
          reg: () => {
            return true
          },
          option: {
            style: { width: "100%" },
            min: 1,
            precision: 0,
            defaultValue: defaultData?.sort
          }
        },
      ],
    };
    return {
      props,
      otherParam: null
    }
  }

  add(defaultValue) {
    let addData = this.getAddData(defaultValue);
    MB.show(
      {
        title: defaultValue ? "编辑数字人席位套餐" : "新增数字人席位套餐",
        okTitle: "确定",
        closeTitle: "取消",
        width: 1000,
        customBtns: <div>
          <Button size={"large"}
            type={"primary"}
            ghost={true}
            onClick={() => {
              this.previewAction()
            }}
          >
            预览</Button>
        </div>
      },
      addData.props
      ,
      {
        otherParam: defaultValue ? {
          _id: defaultValue._id,
          productType: 'human_package'
        } : {
          productType: 'human_package'
        },
        url: defaultValue ? APILXD.pricePackageEdit : APILXD.pricePackageAdd,
        beforeSubmit: (param) => {
          //提交前检查套餐内容格式是否正确
          let comboValidResult = this.comboValid(param)

          if (!comboValidResult) {
            message.warning("请检查套餐内容配置");
            return false;
          }

          param.price = param.comboSet.price;
          param.monthLimit = param.comboSet.month;
          param.monthLimitUnit = '月';
          param.countLimit = param.comboSet.countNum;

          //设置了活动期限
          if (param.eventTimeSet?.length) {
            param.eventStartTime = dayjs(param.eventTimeSet[0]).valueOf();
            param.eventEndTime = dayjs(param.eventTimeSet[1]).valueOf();
          }

          if (param.tagList?.length) {
            param.tagList = param.tagList.map((item) => {
              return typeof item === "string" ? item : item.value;
            });
          }
          if (param.tagListEn?.length) {
            param.tagListEn = param.tagListEn.map((item) => {
              return typeof item === "string" ? item : item.value;
            });
          }

          return true;
        },
        callBack: (state, msg) => {
          //添加成功回调
          state == 'success' && this._loadDataForNet();
        }
      });
  }

  //预览套餐
  previewAction() {
    if (!this.previewData) {
      message.warning("请先配置套餐数据")
      return;
    }

    let comboValidResult = this.comboValid(this.previewData)

    console.log('this.previewData', this.previewData)
    console.log('comboValidResult', comboValidResult)
    if (!comboValidResult) {
      message.warning("请检查套餐内容配置");
      return false;
    }

    let boxWidth = 350;
    let view = <>
      <div className={styles.title} style={{ textAlign: 'center' }}>
        {this.previewData?.name}
      </div>
      <div className={styles.ln} style={{ display: 'flex', alignItems: 'center' }}>
        <img src={require('../../../images/serverPrice/lingneng.png')} alt="" />
        {this.previewData.data?.price / 100}
        <span style={{ fontSize: '16px' }}>灵能</span>
      </div>

      <div className={styles.countLimit} style={{ marginTop: '20px' }}>
        数字人席位 {this.previewData?.data?.countNum} 个
      </div>
      <div className={styles.countLimit}>
        有效期 {this.previewData?.data?.month} 个月
      </div>

      {this.previewData?.remark && (
        <p className={styles.desc} style={{ textAlign: 'center' }}>
          {this.previewData?.remark}
        </p>
      )}
    </>;
    Modal.info({
      title: "套餐预览",
      width: boxWidth,
      content: this.previewData.tagList?.length ? <Badge.Ribbon text={this.previewData.tagList[0]} color={"darkorange"}>
        <div
          className={classNames(styles.priceItem, styles.priceItemChecked)}
        >
          {view}
        </div>
      </Badge.Ribbon> : <div
        className={classNames(styles.priceItem, styles.priceItemChecked)}
      >
        {view}
      </div>,
    })
  }

  /**
   *  列表数据配置
   */
  getTableColumns() {
    return [
      {
        title: '套餐名称',
        dataIndex: 'name',
        key: 'name',
        render: (text, record) => {
          return <Popover
            content={<div
              style={{ maxWidth: '50vw', overflow: 'auto', wordBreak: 'break-all' }}
            >
              {text || "无"}
            </div>}
          >
            <div style={{ position: 'relative', minWidth: 150 }}>
              <div style={{ position: 'absolute', top: -20, left: 0, right: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>中文:{text}</div>
              <div style={{ position: 'absolute', top: 5, left: 0, right: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>英文:{record.nameEn || <span style={{ color: "red" }}>未填写</span>}</div>
            </div>
          </Popover>
        }
      },
      {
        title: '价格(灵能)',
        dataIndex: 'price',
        key: 'price',
        render: (text, record) => {
          return text ? text / 100 : 0
        }
      },
      {
        title: '详情',
        dataIndex: 'detail',
        key: 'detail',
        width: 200,
        render: (text, record, index) => {
          return <div
            style={{ width: 200 }}
          >
            <div>有效期：{Help.getDurationTimeShow(record.monthLimit, record.monthLimitUnit)}</div>
            <div>数字人席位：{record.countLimit}</div>
          </div>
        }
      },
      {
        title: '活动范围',
        dataIndex: 'duration',
        key: 'duration',
        render: (text, record, index) => {
          return <div>
            <div>适用用户：{record.targetTagDesc}</div>
            <div>期限：{record.eventEndTime ? <span>
              {TimeHelp.getYMDFormat(record.eventStartTime, 'yyyy.MM.dd')}
              -
              {TimeHelp.getYMDFormat(record.eventEndTime, 'yyyy.MM.dd')}
            </span> : <span>无限期</span>}</div>
          </div>
        }
      },
      {
        title: '标签',
        dataIndex: 'tagList',
        key: 'tagList',
        render: (text) => {
          return <div style={{ maxWidth: '350px' }}>
            {
              text?.map((str) => {
                return <Tag key={str}>{str}</Tag>
              }) || '-'
            }
          </div>
        }
      },
      {
        title: "标签(英文)",
        dataIndex: "tagListEn",
        key: "tagListEn",
        render: (text) => {
          return (
            <div style={{ maxWidth: "350px" }}>
              {text?.map?.((str) => {
                return <Tag key={str}>{str}</Tag>;
              }) || "-"}
            </div>
          );
        },
      },
      {
        title: '排序',
        dataIndex: 'sort',
        key: 'sort',
        width: 90,
        render: (text) => {
          return text ?? '-'
        }
      },
      {
        title: '状态',
        dataIndex: 'enable',
        key: 'enable',
        render: (text) => {
          return text ? <span style={{ color: 'dodgerblue' }}>已上架</span> :
            <span style={{ color: 'darkorange' }}>已下架</span>
        }
      },
      {
        title: '已售数量',
        dataIndex: 'count',
        key: 'count',
        render: (text) => {
          return text || 0
        }
      },
      {
        title: '操作',
        width: 220,
        render: (text, record, index) => {
          return (
            <div>
              {
                this.powerConfig.Edit
                  ? (record.enable ? <span onClick={() => {
                    this.changeState(record, false)
                  }} style={{ color: "darkorange" }} className={styles.btnCopy}>{"下架"}</span> :
                    <span onClick={() => {
                      if (record.eventEndTime && Date.now() >= record.eventEndTime) {
                        Modal.info({
                          title: "提示",
                          content: "该套餐已过活动有效期，请重新设置后再上架"
                        })
                        return;
                      }

                      if (record.eventStartTime && Date.now() < record.eventStartTime) {
                        Modal.info({
                          title: "提示",
                          content: "该套餐设置了活动有效期，有效期内会自动上架，无需手动调整。"
                        })
                        return;
                      }

                      this.changeState(record, true)
                    }} style={{ color: "dodgerblue" }} className={styles.btnEdit}>{"上架"}</span>)
                  : null
              }
              {
                this.powerConfig.Edit
                  ? <span onClick={() => {
                    this.add(record)
                  }} className={styles.btnEdit}>{"修改"}</span>
                  : null
              }
              {
                this.powerConfig.Delete && !record.enable
                  ? <span onClick={() => {
                    MD.show({
                      title: "提示",
                      okTitle: "确定",
                      closeTitle: "取消",
                    },
                      {}
                      ,
                      {
                        otherParam: { _id: record._id },
                        content: record.name,
                        url: APILXD.pricePackageDel,
                        apiType: 'post',
                        callBack: (state) => {
                          //删除成功回调
                          if (state === "success") {
                            if (this.items?.length === 1 && this.state.page > 1) {
                              //当前页的最后一条
                              this.setState({
                                page: this.state.page - 1
                              }, () => {
                                this._loadDataForNet();
                              })
                            } else {
                              this._loadDataForNet();
                            }
                          }
                        }
                      });
                  }} className={styles.btnDelete}>{"删除"}</span>
                  : null
              }
            </div>
          )
        }
      },
    ]
  }

  changeState(record, enable) {
    Modal.confirm({
      title: '提示',
      content: enable
        ? <div>
          <div>确定上架数字人席位套餐：{record.name} 吗？</div>
          <div style={{ opacity: 0.65, fontSize: 12 }}>上架后用户可以购买该套餐，请谨慎操作。</div>
        </div>
        : <div>
          <div>确定下架数字人席位套餐：{record.name} 吗？</div>
          <div style={{ opacity: 0.65, fontSize: 12 }}>下架后用户将不能购买该套餐，请谨慎操作。</div>
        </div>,
      okText: '确定',
      cancelText: '取消',
      onOk: () => {
        let param = {
          _id: record._id,
          enable,
        };
        let successCB = (code, msg, json, option) => {
          this.setState({ loading: false }, () => {
            message.success('操作成功');
            this._loadDataForNet();
          });
        };
        let failureCB = (code, msg) => {
          this.setState({ loading: false }, () => {
            message.error(msg);
          });
        };

        this.setState({ loading: true });

        HttpTool.post(APILXD.pricePackageDisable, successCB, failureCB, param);
      }
    })
  }
}
